import setCookie from './functions/_cookie-setCookie.js' // Cookie発行
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
import scrollLock from './functions/_scrollLock.js' // スクロールロック

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-sitetop')) {
  pageSiteTop()
}

function pageSiteTop() {
  //    ###    ##     ##  ##  ###    ###  #####
  //   ## ##   ####   ##  ##  ## #  # ##  ##
  //  ##   ##  ##  ## ##  ##  ##  ##  ##  #####
  //  #######  ##    ###  ##  ##      ##  ##
  //  ##   ##  ##     ##  ##  ##      ##  #####

  topAnime()
  function topAnime() {
    const animeFrame = document.getElementById('topAnime')
    const animeWait = document.getElementById('topWait')

    const topAnime = getCookie('topAnime') // 実行済みフラグのCookie取得

    if (location.hash !== '#--anime-reset' && topAnime === '1') {
      animeFrame.classList.add('quick')
      console.log('quick')
      topAnimeEnd()
    } else {
      console.log('def')
      topAnimeMotion()
    }

    function topAnimeMotion() {
      const logo = document.getElementById('topAnime-logo')
      const text = document.getElementById('topAnime-text')

      setTimeout(() => {
        logo.classList.add('active')
      }, 100)
      transitionend(logo, function () {
        logo.classList.remove('active')
        text.classList.add('active')
      })
      transitionend(text, function () {
        topAnimeEnd()
        setCookie('topAnime', '1', 60 * 60 * 24 * 7) // 実行済みフラグのCookie発行
      })
    }
    function topAnimeEnd() {
      animeFrame.classList.remove('active')
      animeWait.classList.add('active')
    }
    function transitionend(item, callFunction) {
      item.addEventListener('transitionend', callFunction)
      item.addEventListener('webkitTransitionend', callFunction)
    }
  }

  //   ####  ##      ##  ####    #####
  //  ##     ##      ##  ##  ##  ##
  //   ###   ##      ##  ##  ##  #####
  //     ##  ##      ##  ##  ##  ##
  //  ####   ######  ##  ####    #####

  let spSliderGroup = []
  const spSliderItem = document.getElementsByClassName('js-spSlider')
  if (spSliderItem[0]) {
    // SP時だけスライダーにする
    if (window.matchMedia('(max-width:800px)').matches) {
      for (const targetSlider of spSliderItem) {
        const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
        spSliderInit(targetSlider, sliderName)
      }
    }
    window.addEventListener('resize', function (e) {
      if (window.matchMedia('(min-width:801px)').matches) {
        for (const targetSlider of spSliderItem) {
          const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
          if (spSliderGroup[sliderName]) {
            // スライドが定義されていれば破棄
            spSliderGroup[sliderName].destroy()
            spSliderGroup[sliderName] = false
          }
        }
      } else if (window.matchMedia('(max-width:800px)').matches) {
        for (const targetSlider of spSliderItem) {
          const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
          if (!spSliderGroup[sliderName]) {
            // スライドが未定義なら初期化
            spSliderInit(targetSlider, sliderName)
          }
        }
      }
    })
  }
  function spSliderInit(targetSlider, sliderName) {
    spSliderGroup[sliderName] = new Swiper(targetSlider, {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },
    })
  }

  //  ###    ###   #####   ####      ###    ##
  //  ## #  # ##  ##   ##  ##  ##   ## ##   ##
  //  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
  //  ##      ##  ##   ##  ##  ##  #######  ##
  //  ##      ##   #####   ####    ##   ##  ######

  const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
  const modals = document.getElementsByClassName('js-modal') // モーダル本体
  const modalYoutube = document.getElementsByClassName('js-modal-youtube') // モーダル内YouTube
  if (modals[0]) {
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.js-modal-open')) {
        return
      }
      e.preventDefault()
      modalClose()
      const target = e.target.closest('.js-modal-open').dataset.modal

      const openModals = document.querySelectorAll('.js-modal--' + target)
      for (const openModal of openModals) {
        openModal.classList.add('active')
      }

      modalOverlay.classList.add('active')
      scrollLock('body', '#modalOverlay')

      // YouTubeのsrcを読み込む
      const youtube = document.querySelector('.js-modal--' + target + ' .js-modal-youtube')
      if (youtube) {
        youtube.setAttribute('src', youtube.dataset.src)
      }
    })
    // モーダル撤去
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.js-modal-close')) {
        return
      }
      e.preventDefault()
      modalClose()
      modalOverlay.classList.remove('active')
      scrollLock('body', '#modalOverlay')
    })
  }

  function modalClose() {
    // モーダルを消す
    for (let index = 0; index < modals.length; index++) {
      const modal = modals[index]
      modal.classList.remove('active')
    }
    // YouTubeのsrcを消して動画を止める
    for (let index = 0; index < modalYoutube.length; index++) {
      modalYoutube[index].setAttribute('src', '')
    }
  }
}
